import type { ButtonProps } from '@packages/shared';
import { Button, Link } from '@packages/shared';
import {
  ArrowLargeRight32,
  ArrowLargeLeft32,
  ArrowMediumRight32,
  ArrowMediumLeft32,
  ArrowMiniRight32,
  ArrowMiniLeft32,
} from '@packages/themes/icons';
import type { DrupalIconTypes, Size } from '../../../interfaces';
import { ComponentTypes } from '../../../interfaces';
import { buildLinkWithArguments } from '../../utils';
import { registerComponents } from '../ComponentRecognizer/componentRegistry';
import type { LinkByButtonType, Icon } from './types';

const getIcon = (icon: Icon, size: Size) => {
  const icons = {
    ArrowRight: {
      small: <ArrowMiniRight32 />,
      medium: <ArrowMediumRight32 />,
      large: <ArrowLargeRight32 />,
    },
    ArrowLeft: {
      small: <ArrowMiniLeft32 />,
      medium: <ArrowMediumLeft32 />,
      large: <ArrowLargeLeft32 />,
    },
  };

  return icons[icon][size];
};

export const LinkByButton = ({
  data,
  icon,
}: {
  data: LinkByButtonType;
  icon?: DrupalIconTypes;
}) => {
  const {
    field_link: link,
    field_text: text,
    field_layout: color,
    field_css_class: cssClass,
    behavior_paragraph_size: behaviorSize,
    field_link_target: linkTarget,
  } = data;

  const finalColor = (
    color && !color.match(/base|greyDark|greyLight/g) ? color : undefined
  ) as ButtonProps['color'];

  const iconElement = icon && behaviorSize && getIcon(icon, behaviorSize);
  const iconPosition = icon && icon.startsWith('ArrowRight') ? 'endIcon' : 'startIcon';

  return (
    <Button
      LinkComponent={Link}
      href={buildLinkWithArguments(link, data)}
      color={finalColor}
      className={cssClass}
      {...(behaviorSize && {
        size: behaviorSize,
      })}
      {...(icon && iconElement && { [iconPosition]: iconElement })}
      target={linkTarget || '_self'}
    >
      {text}
    </Button>
  );
};

// Needed to run this component in Storybook and Jest tests. Register the component in a global componentRegistry object
registerComponents({ [ComponentTypes.LinkByButton]: LinkByButton });
